import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CurrenciesPositionReport } from '../types';
import { currenciesPositionApi } from './service';

export interface CurrenciesPositionState {
  currenciesPosition?: CurrenciesPositionReport;
  formationTime?: {
    start?: number;
    end?: number;
    duration?: number;
  };
}

const initialState: CurrenciesPositionState = {
  currenciesPosition: undefined,
  formationTime: undefined,
};

export const currenciesPositionSlice = createSlice({
  name: 'currenciesPosition',
  initialState,
  reducers: {
    clearCurrenciesPositionState: (state) => {
      state.currenciesPosition = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        currenciesPositionApi.endpoints.getCurrenciesPositionReport
          .matchPending,
        (state) => {
          state.formationTime = {
            start: Date.now(),
            end: undefined,
            duration: undefined,
          };
        },
      )
      .addMatcher(
        currenciesPositionApi.endpoints.getCurrenciesPositionReport
          .matchFulfilled,
        (
          state,
          action: PayloadAction<{ data: CurrenciesPositionReport }> & {
            meta: { fulfilledTimeStamp: number };
          },
        ) => {
          state.currenciesPosition = action.payload.data;

          state.formationTime = {
            ...state.formationTime,
            end: action.meta.fulfilledTimeStamp,
            duration: Math.round(
              (action.meta.fulfilledTimeStamp -
                (state.formationTime?.start as number)) /
                1000,
            ),
          };
        },
      );
  },
});

export const { clearCurrenciesPositionState } = currenciesPositionSlice.actions;

export default currenciesPositionSlice.reducer;
